import { memo } from 'react';

import CatalogGrid from '@features/marketplace/catalog/CatalogGrid';
import { ProductDetails } from 'helpers/fakeData';

interface Props {
  products: ProductDetails[];
}

const CatalogPage = ({ products }: Props) => {
  return <CatalogGrid products={products} />;
};

export default memo(CatalogPage);
